import React, {useEffect, useRef, useState} from 'react';
import useOutsideDetector from "../../utils/hooks/useOutsideDetector";

interface Props {
    button: JSX.Element;
    body: JSX.Element;
    bodyWrapperClassName?: string;
}

const DropdownWrapper = ({button, body, bodyWrapperClassName}: Props) => {
    const [show, setShow] = useState(false)
    const classes = "z-20 origin-top-right absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none " + bodyWrapperClassName;
    const wrapperRef = useRef(null);
    const outSide = useOutsideDetector(wrapperRef);
    useEffect(()=>{
        setShow(false)
    },[outSide])
    return (
        <div ref={wrapperRef} className="relative">
            <div onClick={() => setShow((prevState) => !prevState)}>
                {button}
            </div>
            {show && <div
                className={classes}>
                {body}
            </div>}
        </div>
    );
};

export default DropdownWrapper;
